import { atom } from 'recoil';

export const reportsPopoverAtom = atom<number | null>({
	key: 'reportsPopover',
	default: null,
});
